import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useModalRouter from 'hooks/useModalRouter';

import { AUTOMATION, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author @buunsal
 */
const AutomationList = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.number, width: 50, show: false },
			{
				Header: 'name',
				accessor: 'name',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			},
			{
				Header: 'whenThisHappens',
				accessor: 'triggerEvent',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'modifiedBy',
				accessor: 'modifiedBy',
				filterType: FilterType.string
			},
			{
				Header: 'modifiedDate',
				accessor: 'modifiedDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ACTIVE_INACTIVE,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			}
		],
		[]
	);
	const { showModal } = useModalRouter();

	return (
		<div>
			<PageHeader
				title="automationList"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/automation-icon.json.gz">
				<Authorization path="/modal/automation-form">
					<Button
						icon={faPlus}
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						label="addAutomation"
						onClick={() => showModal('automation-form')}
						variant="blue"
						className="addButton"
					/>
				</Authorization>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.AUTOMATION}
				columns={columns}
				fetchUrl={AUTOMATION.GET_AUTOMATION_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="automation"
			/>
		</div>
	);
};

export default AutomationList;
